module.exports = {
      id: "share-menu-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#share-menu",
      toString: function () {
        return this.url;
      }
    }